import { HoverCard, HoverCardTrigger, HoverCardContent } from "@/components/ui/hover-card";

export function ProductHoverPreview({ imgSrc, description, itemNo, variants, children }) {
  return (
    <HoverCard openDelay={150} closeDelay={0}>
      <HoverCardTrigger asChild>{children}</HoverCardTrigger>
      <HoverCardContent
        side="right"
        align="start"
        className="w-72 rounded-sm border-zinc-300 bg-white p-3 shadow-xl"
        data-testid="product-hover-preview"
      >
        {imgSrc ? (
          <img
            src={imgSrc}
            alt="preview"
            className="mb-2 h-52 w-full rounded-sm border border-zinc-200 bg-zinc-50 object-contain"
          />
        ) : (
          <div className="mb-2 flex h-52 w-full items-center justify-center rounded-sm border border-zinc-200 bg-zinc-50 text-xs text-zinc-400">
            No image
          </div>
        )}
        <div className="text-xs font-semibold text-zinc-900" data-testid="product-hover-preview-item-no">
          {itemNo || "-"}
        </div>
        <div className="mb-2 line-clamp-2 text-xs text-zinc-600" data-testid="product-hover-preview-description">
          {description || "-"}
        </div>
        {variants && variants.length > 0 && (
          <table className="w-full text-[11px]" data-testid="product-hover-preview-variants">
            <thead>
              <tr className="text-zinc-400">
                <th className="text-left font-normal">Size</th>
                <th className="text-right font-normal">QTY</th>
                <th className="text-right font-normal">Price</th>
              </tr>
            </thead>
            <tbody>
              {variants.map((v) => (
                <tr key={v.recordId} className="border-t border-zinc-100" data-testid={`product-hover-preview-variant-row-${v.recordId}`}>
                  <td className="py-0.5">{(v["product::Size"] || "").trim() || "-"}</td>
                  <td className="py-0.5 text-right font-mono-data" data-testid={`product-hover-preview-inventory-qty-${v.recordId}`}>
                    {v["product::inventory qty"] != null ? Math.round(v["product::inventory qty"]) : "-"}
                  </td>
                  <td className="py-0.5 text-right font-mono-data">
                    ${(Number(v["product::Price"]) || 0).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </HoverCardContent>
    </HoverCard>
  );
}
